module.exports = __webpack_public_path__ + "img/back.eb3c8213.svg";